// extracted by mini-css-extract-plugin
export var legendIndicator = "_8i-1";
export var legendRight = "_8i-0";